
export default {
  head() {
    return {
      title:
        "Agence Google Ads | SEA à Noisy-le-Grand dès 290€/mois - ALEO AGENCY",
      meta: [
        {
          hid: "description",
          name: "description",
          content:
            "ALEO, agence Google Ads à Noisy-le-Grand certifiée Google Partner, accompagne les entreprises noiséennes pour améliorer leur visibilité en ligne et attirer plus de clients.",
        },
        {
          hid: "og:title",
          property: "og:title",
          content:
            "Agence Google Ads à Noisy-le-Grand dès 290€/mois - ALEO AGENCY",
        },
        {
          hid: "og:description",
          property: "og:description",
          content:
            "ALEO, agence Google Ads à Noisy-le-Grand certifiée Google Partner, accompagne les entreprises noiséennes pour améliorer leur visibilité en ligne et attirer plus de clients.",
        },
      ],
    };
  },
};
